<template>
  <div class="contain contain_box_lg">
    <!-- <img src="../assets/img/container2.png" class="contain_box_lg" alt /> -->
    <div class="box-login">
      <div class="login-inpt">
        <div class="login-ph">请登录</div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <el-form-item label prop="userName">
            <el-input
              class="log-input"
              type="text"
              v-model="ruleForm.userName"
              prefix-icon="username-icon"
              auto-complete="off"
              placeholder="请输入手机号码"
              @keyup.enter.native="login('ruleForm')"
            ></el-input>
            <span class="log-require">*</span>
          </el-form-item>
          <el-form-item label prop="passwd">
            <el-input
              class="log-input"
              type="password"
              v-model="ruleForm.passwd"
              prefix-icon="password-icon"
              auto-complete="off"
              placeholder="请输入密码"
              @keyup.enter.native="login('ruleForm')"
            ></el-input>
            <span class="log-require">*</span>
          </el-form-item>
          <el-form-item>
            <el-col :span="12" style="text-align: left;line-height: normal;">
              <el-checkbox v-model="autoLogin" style="color:#1B1464;">自动登录</el-checkbox>
            </el-col>
            <el-col :span="6" style="line-height: normal">
              <el-button type="type" class="login-btn-rw" @click="freeRegister()">免费注册</el-button>
            </el-col>
            <el-col :span="6" style="line-height: normal">
              <el-button type="type" class="login-btn-rw" @click="forgetPw()">忘记密码</el-button>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-button class="login-btn" @click.prevent="login('ruleForm')">登录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <img src="../assets/img/container2.png" class="contain_box_lg" alt />
  </div>
</template>

<script>
// import ElCol from "element-ui/packages/col/src/col";
// import ElFormItem from "../../node_modules/element-ui/packages/form/src/form-item";
// import ElButton from "../../node_modules/element-ui/packages/button/src/button";
export default {
  // components: { ElButton, ElFormItem, ElCol },
  data() {
    var validateUserName = (rule, value, callback) => {
      var regPhone = /^1[3456789]\d{9}$/; //手机号校验正则
      if (value === "") {
        callback(new Error("请输入手机号码"));
      } else if (!regPhone.test(value)) {
        callback(new Error("手机号码格式有误，请输入正确的手机号码"));
      } else {
        callback();
      }
    };
    var validatePassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };
    return {
      autoLogin: false, //默认不自动登录
      ruleForm: {
        userName: "", //用户名
        passwd: "" //密码
      },
      rules: {
        userName: [{ validator: validateUserName, trigger: "blur" }],
        passwd: [{ validator: validatePassword, trigger: "blur" }]
      }
    };
  },
  methods: {
    //登录
    login(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          var that = this;
          let data = {};
          data.userDomainCode = "SSLCP";
          data.userAccountName = that.ruleForm.userName;
          data.password = that.ruleForm.passwd;
          let response = that.apiService
            .post("/sinoslog-ops-service/user/login", data)
            .then(res => {
              if (res.data.data.data && res.data.data.msg) {
                if (that.autoLogin) {
                  //自动登录设置账户和密码7天有效
                  that.$cookies.set("username", that.ruleForm.userName, "7d");
                  that.$cookies.set("password", that.ruleForm.passwd, "7d");
                } else {
                  //浏览器关闭失效
                  that.$cookies.set("username", that.ruleForm.userName, 0);
                  that.$cookies.set("password", that.ruleForm.passwd, 0);
                }
                localStorage.setItem(
                  "userInfo",
                  JSON.stringify(res.data.data.data)
                ); //用户信息
                that.$router.go(-1);
                let lens = JSON.parse(localStorage.getItem("queryData"));
                if (lens) {
                  this.$router.push({
                    name: "ShipSchedule",
                    params: {
                      startPortCode: lens.startPortCode,
                      startPort: lens.startPort,
                      reachPortCode: lens.reachPortCode,
                      reachPort: lens.reachPort,
                      startItem: lens.startItem[0],
                      reachItem: lens.reachItem[0]
                    }
                  });
                }
              } else {
                that.$message({
                  showClose: true,
                  customClass: "register-bg",
                  message: "用户名或密码错误",
                  type: "error",
                  offset: 300
                });
              }
            });
        } else {
          return false;
        }
      });
    },

    //免费注册
    freeRegister() {
      this.$router.push({ name: "Register" });
    },
    //忘记密码
    forgetPw() {
      this.$router.push({ name: "ForgetPassword" });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.username-icon {
  background-image: url("../assets/img/username.png");
  background-size: contain;
  background-repeat: no-repeat;
  padding: 2px 8px;
  margin: 0 5px;
}

.password-icon {
  background-image: url("../assets/img/password.png");
  background-size: contain;
  background-repeat: no-repeat;
  padding: 2px 8px;
  margin: 0 5px;
}

.login-inpt {
  padding: 30px 30px 10px 30px;
  width: 330px;
  background-color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1;
  margin-left: -170px;
  margin-top: -220px;
}

.login-ph {
  font-family: "SourceHanSans-Medium";
  text-align: left;
  padding-bottom: 20px;
}
.box-login {
  width: 1200px !important;
  margin: 0 auto !important;
  /* position: relative; */
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue